export default __webpack_public_path__ + "static/media/start.b0836585.png";